//local
/*const url="dev.jbp.com.ec";
const urlVmf="localhost:3000";
const urlAppWeb="apptest.jbp.com.ec";
//const urlSignalR="http://localhost:5002";
const urlSignalR="http://signalr.jbp.com.ec";*/

//pruebas
/*const url="test.jbp.com.ec";
const urlVmf="servicesvmftest.jbp.com.ec";
const urlAppWeb="apptest.jbp.com.ec";
const urlSignalR="http://signalr.jbp.com.ec";*/

//produccion
const url="services.jbp.com.ec";
const urlVmf="servicesvmf.jbp.com.ec";
const urlAppWeb="app.jbp.com.ec";
const urlSignalR="http://signalr.jbp.com.ec";


const conf=[
    {
        "name": "urlWebServices",
        "value":[
            {
                "endPointName": "cartera",
                "url": "http://"+url+"/api/vendor/getCarteraByCodVendedor"
            },
            {
                "endPointName": "vendedor",
                "url": "http://"+url+"/api/vendor/"
            },
            {
                "endPointName": "clients",
                "url": "http://"+url+"/api/socioNegocio/getBycodVendedor"
            },
            {
                "endPointName": "socioNegocio",
                "url": "http://"+url+"/api/socioNegocio"
            },
            {
                "endPointName": "products",
                "url": "http://"+url+"/api/product/getSellProducts"
            },
            {
                "endPointName": "order",
                "url": "http://"+url+"/api/orden"
            },
            {
                "endPointName": "pago",
                "url": "http://"+url+"/api/pago"
            },
            {
                "endPointName": "syncOrders",
                "url": "http://"+url+"/api/orden/getOrdersByVendor"
            },
            {
                "endPointName": "banks",
                "url": "http://"+url+"/api/catalogos/getbancosecuador"
            },
            {
                "endPointName": "reacciones",
                "url": "http://"+url+"/api/reacciones/"
            },
            {
                "endPointName": "catalogReacciones",
                "url": "http://"+url+"/api/reacciones/getCatalogos"
            },
            {
                "endPointName": "catalogProveedoresEM",
                "url": "http://"+url+"/api/socioNegocio/getProveedoresEM"
            },
            {
                "endPointName": "bodega",
                "url": "http://"+url+"/api/bodega"
            },
            {
                "endPointName": "entradaMercanciaCompra",
                "url": "http://"+url+"/api/EntradaMercanciaCompra"
            },
            {
                "endPointName": "user",
                "url": "http://"+url+"/api/user"
            },
            {
                "endPointName": "bodegasConUbicaciones",
                "url": "http://"+url+"/api/bodega/getBodegasConUbicaciones"
            },
            {
                "endPointName": "bodegas",
                "url": "http://"+url+"/api/bodega/getBodegas"
            },
            {
                "endPointName": "ubicaciones",
                "url": "http://"+url+"/api/bodega/getUbicaciones"
            },
            {
                "endPointName": "transferenciaStock",
                "url": "http://"+url+"/api/tsUbicaciones"
            },
            {
                "endPointName": "tsFromPesajeToMat",
                "url": "http://"+url+"/api/tsFromPesajeToMat"
            },
            {
                "endPointName": "tsFromST",
                "url": "http://"+url+"/api/tsFromST"
            },
            {
                "endPointName": "solicitudTransferencia",
                "url": "http://"+url+"/api/st"
            },
            {
                "endPointName": "urlConsultaLoteArticulo",
                "url": "http://"+urlAppWeb+"/consultaLote?lote="
            },
            {
                "endPointName": "urlConsultaUbicacion",
                "url": "http://"+urlAppWeb+"/consultaUbicacion?ubicacion="
            },

            {
                "endPointName": "infoVisitador",
                "url": "http://"+urlVmf+"/visitador/getByMail"
            },
            {
                "endPointName": "visitador",
                "url": "http://"+urlVmf+"/visitador"
            },
            {
                "endPointName": "visitas",
                "url": "http://"+urlVmf+"/visitador/saveVisitas"
            },
            {
                "endPointName": "pedidos",
                "url": "http://"+urlVmf+"/pedido/savePedidos"
            },
            
            {
                "endPointName": "visitasPendientes",
                "url": "http://"+urlVmf+"/visitador/getVisitasPendientesByEmailRepresentante"
            },
            {
                "endPointName": "visitasCicloAnterior",
                "url": "http://"+urlVmf+"/visitador/getVisitasCicloAnteriorByEmailRepresentante"
            },
            {
                "endPointName": "pedido",
                "url": "http://"+urlVmf+"/pedido"
            },
            {
                "endPointName": "pedidosPorRepresentante",
                "url": "http://"+urlVmf+"/pedido/getByEmailRepresentante"
            },
            {
                "endPointName": "medicos",
                "url": "http://"+urlVmf+"/medico/getByEmailRepresentante"
            },
            {
                "endPointName": "farmacias",
                "url": "http://"+urlVmf+"/farmacia/getByEmailRepresentante"
            },
            {
                "endPointName": "espaciosContratados",
                "url": "http://"+urlVmf+"/farmacia/getEspaciosContratados"
            },
            {
                "endPointName": "inventario",
                "url": "http://"+urlVmf+"/articulo/getInventarioByEmailRepresentante"
            },
            {
                "endPointName": "articulosVenta",
                "url": "http://"+urlVmf+"/articulo/getArticulosVenta"
            },
            {
                "endPointName": "articulosCompetencia",
                "url": "http://"+urlVmf+"/articulo/getArticulosCompetencia"
            },
            
            {
                "endPointName": "materialPromocional",
                "url": "http://"+urlVmf+"/articulo/getMaterialPromocional"
            },
            {
                "endPointName": "distribuidores",
                "url": "http://"+urlVmf+"/distribuidor/getall"
            },
            {
                "endPointName": "ciclos",
                "url": "http://"+urlVmf+"/ciclo/getCiclos"
            },
            {
                "endPointName": "especialidades",
                "url": "http://"+urlVmf+"/articulo/getEspecialidades"
            },
            
        ]
    },
    {
        "name": "masterPwd",
        "value": "AtLsV971*"
    },
    {
        "name": "urlSignalR",
        "value": urlSignalR
    }
]
export default conf

